module.exports = __webpack_public_path__ + "media/build-towers.34bf5ee3.mp4";